const fdaDrugsTheme = {
  dot: "bg-rose-400",
  accentText: "text-rose-200",
  subtleText: "text-rose-300",
  tabActive: "border-rose-400/40 bg-rose-500/10 text-rose-100",
  selectedRow: "border-l-2 border-rose-400 bg-rose-500/[0.08]",
  accentBadge: "border border-rose-400/30 bg-rose-500/10 text-rose-100",
  idBadge: "border border-rose-400/25 bg-rose-500/5 text-rose-100",
  detailBorder: "border-rose-400/25",
  detailGlow: "from-rose-400/25",
  checkbox:
    "border-rose-300/40 text-rose-200 hover:border-rose-200/60 hover:bg-rose-950/70 focus-visible:ring-rose-300/25",
  checkboxChecked:
    "border-rose-100/70 from-rose-300 to-red-400 shadow-[0_0_0_1px_rgba(254,205,211,0.16),0_10px_22px_rgba(244,63,94,0.24)]",
};

export default fdaDrugsTheme;
